/**
 * Simulated Response Factory
 *
 * Generates realistic demo responses for the ChatBot conversation flow.
 * Intended for UI validation, UX reviews, demos, and frontend development.
 * Will be replaced by real backend integration in production.
 */

export class SimulatedResponseFactory {
  private readonly responseVariations = [
    [
      'I found relevant information related to your request.',
      'Here is a detailed analysis of your inquiry.',
      'Based on the available data, here is what I discovered.',
      'I analyzed the data and found the following insights.',
      'Let me break down the information for you.',
    ],
    [
      'Thanks for the additional context. I understand better now.',
      'That clarifies things. Let me provide more specific details.',
      "With that context, here's what I can tell you.",
      'I see. Let me give you a more detailed response.',
      'That helps me understand your needs better.',
    ],
    [
      'This is a simulated AI response. Backend integration is pending.',
      'Running in demo mode with simulated data.',
      'This response demonstrates the conversation UI functionality.',
      'Live data connection is coming in the next phase.',
      'Currently showing simulated results for demonstration.',
    ],
    [
      'I found 5 relevant records matching your criteria.',
      'The analysis covers 12 data points from your request.',
      'Here are the top 3 results based on your query.',
      'I processed 150+ records to provide this insight.',
      'The findings are based on the latest available data.',
    ],
    [
      'Would you like me to dig deeper into any specific area?',
      'Do you need more details on any particular aspect?',
      'Should I focus on a specific plant or time period?',
      'Would additional filters help narrow down the results?',
      "Is there a specific metric you'd like to explore further?",
    ],
  ];

  /**
   * Generates a simulated assistant response.
   * Randomly selects from multiple response variations
   * to make interactions feel more natural.
   */
  generateResponse(): string {
    const variationSet = this.responseVariations[Math.floor(Math.random() * this.responseVariations.length)];

    return variationSet[Math.floor(Math.random() * variationSet.length)];
  }
}
